
import { motion } from 'framer-motion';

export default function PortfolioHero() {
  return (
    <section className="relative pt-32 sm:pt-40 pb-16 sm:pb-20 overflow-hidden bg-brand-beige-light">
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block bg-brand-green/10 text-brand-green text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
            Referenzen
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            Portfolio & Projekte
          </h1>
          <p className="text-lg sm:text-xl text-brand-grey max-w-3xl mx-auto px-4">
            Hier entsteht mein Portfolio. Die unten gezeigten Projekte sind Beispiele,
            die meine Arbeitsweise und mein Designstil veranschaulichen.
          </p>
        </motion.div>

        {/* Honest notice banner */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8 max-w-2xl mx-auto"
        >
          <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-5 py-4 text-left">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-amber-500 text-lg"></i>
            </div>
            <p className="text-sm text-amber-800 leading-relaxed">
              <span className="font-semibold">Hinweis:</span> Ich stehe noch am Anfang meiner Selbstständigkeit.
              Die gezeigten Projekte sind Beispiele meiner Fähigkeiten – keine abgeschlossenen Kundenprojekte.
              Echte Referenzen folgen, sobald die ersten Projekte abgeschlossen sind.{' '}
              <span className="font-semibold">Sei einer meiner ersten Kunden!</span>
            </p>
          </div>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="mt-10 grid grid-cols-3 gap-6 max-w-2xl mx-auto"
        >
          {[
            { value: '100%', label: 'Einsatz & Leidenschaft' },
            { value: '< 1 Woche', label: 'Ø Lieferzeit' },
            { value: '0€', label: 'Erstgespräch kostenlos' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl sm:text-3xl font-caprasimo text-brand-green">{stat.value}</div>
              <div className="text-xs sm:text-sm text-brand-grey mt-1">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
